import React, { createContext } from 'react';
import { Navbar } from '../Navbar/Navbar'
import { Outlet, useLoaderData } from "react-router-dom";
export const QuizzesContext = createContext([]);
const Layout = () => {
    const quizzes = useLoaderData();
    return (
        <div>
            <QuizzesContext.Provider value={quizzes}>
                <Navbar></Navbar>
                <Outlet></Outlet>
            </QuizzesContext.Provider>

        </div>
    );
};

export default Layout;